import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { translations } from '@/locales/index';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = Object.assign(translations);
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      (messages as any)[locale] = locales(key);
    }
  });
  return messages;
}

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'name'
    }
  },
  jp: {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    decimal: {
      style: 'decimal',
      currency: 'JPY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  }
};

export default new VueI18n({
  silentFallbackWarn: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'jp',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'jp',
  messages: loadLocaleMessages(),
  numberFormats
});
